<div class="relative">
    <div class="container w-full">
        <div class="w-full flex flex-col sm:flex-row sm:justify-between border-b border-[#bb0021] pb-2">
            <div class="flex items-center gap-3 w-full">
                <tui-svg src="tuiIconList" style="color: black;"></tui-svg>
                <h3 class="text-black text-[1.5rem] font-bold">Activity Logs</h3>
            </div>

            <div>
                <button tuiButton appearance="" (click)="toggle()">
                    <div class="flex justify-center gap-2 items-center btn-outline w-[80px] sm:w-[190px]">
                        <tui-svg src="tuiIconSlidersLarge" class="sm:pt-3 rotate-90 flex items-center"
                            style="color: #bb0021;"></tui-svg>
                        <p class="hidden sm:block">Advanced Search</p>
                    </div>
                </button>
            </div>
        </div>

        <tui-loader [overlay]="true" [showLoader]="isLoading">
            <!-- Advanced Search -->
            <div *ngIf="showSearch" class="flex sm:items-center gap-1 flex-col sm:flex-row mt-2">
                <div class="w-full sm:w-60">
                    <tui-input tuiTextfieldIconLeft="tuiIconSearchLarge" [tuiTextfieldCleaner]="false"
                        tuiTextfieldSize="m" [tuiTextfieldLabelOutside]="true" [(ngModel)]="searchText">
                        Search
                        <input tuiTextfield type="text" />
                    </tui-input>
                </div>
                <div class="bg-[#6A6A6A] h-10 w-[1px] hidden sm:block"></div>
                <div class="w-full sm:w-[100px]">
                    <button tuiButton tuiTextfieldSize="s" type="button" class="w-full" (click)="search()">
                        <tui-svg src="tuiIconSearchLarge" class="pr-2 text-white"></tui-svg>
                        <span class="text-white">Search</span>
                    </button>
                </div>
            </div>

            <!-- Logs Table -->
            <div class="mt-3">
                <div *ngIf="filteredList.length > 0" class="overflow-x-scroll">
                    <table class="tui-table w-full">
                        <thead tuiThead>
                            <tr class="tui-table__tr">
                                <th class="tui-table__th">Date</th>
                                <th class="tui-table__th">User</th>
                                <th class="tui-table__th">Action</th>
                                <th class="tui-table__th">Description</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="tui-table__tr" *ngFor="let log of filteredList">
                                <td class="tui-table__td">{{ log.date | date: 'yyyy-MM-dd' }}</td>
                                <td class="tui-table__td">{{ log.user }}</td>
                                <td class="tui-table__td">{{ log.action }}</td>
                                <td class="tui-table__td">{{ log.description }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- No Data -->
                <div *ngIf="filteredList.length === 0 && !isLoading" class="mt-3 text-center text-[#D8D8D8]">
                    No Data
                </div>
            </div>
        </tui-loader>
    </div>
</div>